import { render } from "./transport-list-virtual-scroll.vue?vue&type=template&id=3b2a04ae"
import script from "./transport-list-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./transport-list-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__